import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { EnvironmentService } from '@nomoh-monorepo/shared-data-access-environment';
import { IFaq, IFaqFiltro, IResponse } from '@nomoh-monorepo/shared-types';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FaqAdminDataService {
  private http = inject(HttpClient);
  private env = inject(EnvironmentService);
  private baseUrl = `${this.env.getApiUrl('nomoh')}/faq`;

  private _faqs = signal<IFaq[]>([]);
  private _loading = signal(false);

  $faqs = this._faqs.asReadonly();
  $loading = this._loading.asReadonly();

  async carregar(filtro: IFaqFiltro = {}): Promise<void> {
    this._loading.set(true);
    try {
      const response = await firstValueFrom(
        this.http.post<IResponse<IFaq[]>>(`${this.baseUrl}/admin/findAll`, {
          offSet: 0,
          limit: 100,
          ordenacao: -1,
          param: 'dataInclusao',
          ...filtro,
        })
      );
      this._faqs.set(response.data ?? []);
    } finally {
      this._loading.set(false);
    }
  }

  async salvar(faq: Partial<IFaq>): Promise<void> {
    const url = faq.id ? `${this.baseUrl}/update` : `${this.baseUrl}/create`;
    await firstValueFrom(this.http.post(url, faq));
    await this.carregar();
  }

  async desativar(id: string): Promise<void> {
    await firstValueFrom(this.http.post(`${this.baseUrl}/delete`, { id }));
    await this.carregar();
  }
}
